import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { AppDivisionContext } from '../../../contexts/AppDivisionContext';
import { isInspectionSigned } from '../../../contexts/InspectionContext';
import {
  ProjectAsset,
  projectAssetsApi,
} from '../../../utils/api/projectAsset';
import { MapEditorRouteContext } from '../../CustomRoutes/MapEditor';
import CreateAssetModal from '../../Projects/Details/Assets/CreateAssetModal';
import { Context as DataSourceContext } from '../DataSourceContext';

interface IAssetCreateActionProps {
  toggleActive: (forceActive?: boolean) => void;
  setInteractionMode: (mode: string, modeData?: any) => void;
  pixelFor: (asset: ProjectAsset) => number[] | null;
}

/**
 * the ⊕ on the map's Assets list. Creates an asset on the selected
 * inspection's form, then places it: at its coordinates on a calibrated map
 * when they fall inside it, otherwise where the user clicks.
 */
const AssetCreateAction: React.FC<IAssetCreateActionProps> = ({
  toggleActive,
  setInteractionMode,
  pixelFor,
}) => {
  const { projectId, selectedInspection } = useContext(MapEditorRouteContext);
  const { appDivisionId } = useContext(AppDivisionContext);
  const dataSource = useContext(DataSourceContext);
  const [open, setOpen] = useState(false);

  if (!selectedInspection || isInspectionSigned(selectedInspection)) {
    return null;
  }

  const place = async (created: ProjectAsset) => {
    try {
      const asset = await projectAssetsApi.show(
        projectId,
        created.id,
        selectedInspection.id,
      );
      const pixel = pixelFor(asset);

      dataSource.updateArrayItem('asset_type', {
        ...asset,
        positionableType: 'asset_type',
      });
      toggleActive(true);
      setInteractionMode('create', {
        sourceModelId: asset.id,
        mapEvent: pixel ? { coordinate: pixel } : undefined,
      });
    } catch {
      toast.error('The asset was created but could not be added to the map.');
    }
  };

  return (
    <>
      <span
        className='positionable-list-group-add positionable-list-group-action'
        title='Create asset'
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      >
        <AddCircleOutlineIcon style={{ height: '22px', width: '22px' }} />
      </span>

      {open && (
        <CreateAssetModal
          projectId={projectId}
          divisionId={appDivisionId || 0}
          lockedInspectionTemplateId={selectedInspection.inspection_template?.id}
          onSaved={place}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default AssetCreateAction;
